import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const hashtags = [
  '#spirituelebescherming',
  '#bozeoog',
  '#energiereiniging',
  '#spiritueel',
  '#aura',
  '#hindoestaans',
  '#surinaams',
  '#zpiritualz',
  '#hingolie',
  '#reinigingsritueel',
  '#bescherming',
  '#hing',
];

const instaPosts = [
  {
    id: 1,
    image: 'https://public.readdy.ai/ai/img_res/c7e7d539e74cbadd4263a58b2139309a.jpg',
    likes: '1.2K',
    caption: 'Het badritueel dat alles verandert ✨ Evil Energy Destroy Zeep + Cologne = complete reiniging',
    tag: '#reinigingsritueel',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=blue%20protect%20balls%20indigo%20blue%20spheres%20dissolving%20in%20water%20mystical%20spiritual%20bath%20ritual%20dark%20elegant%20background%20blue%20glow%20water%20ripples%20close%20up%20product%20photography&width=600&height=600&seq=insta2&orientation=squarish',
    likes: '987',
    caption: 'Blue Protect Balls in bad 💙 Voel het verschil na de eerste keer',
    tag: '#bozeoog',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=hing%20asafoetida%20powder%20burning%20incense%20smoke%20rising%20dark%20background%20mystical%20spiritual%20cleansing%20ritual%20smoke%20photography%20atmospheric%20moody%20ancient%20protection%20ritual%20close%20up&width=600&height=600&seq=insta3&orientation=squarish',
    likes: '2.1K',
    caption: 'Hing branden na bezoek 🔥 De geur die kwaad wegjaagt — al eeuwenlang bewezen',
    tag: '#energiereiniging',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=evil%20energy%20destroy%20kit%20unboxing%20flat%20lay%20dark%20background%20abalone%20shell%20white%20candle%20herbs%20incense%20ritual%20kit%20complete%20set%20dark%20stone%20surface%20warm%20dramatic%20lighting%20product%20photography&width=600&height=600&seq=insta4&orientation=squarish',
    likes: '3.4K',
    caption: 'Unboxing de Evil Energy Destroy Kit 📦 Alles wat je nodig hebt in één pakket',
    tag: '#zpiritualz',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=baby%20hing%20pasta%20protection%20cream%20jar%20warm%20golden%20amber%20color%20soft%20mystical%20spiritual%20baby%20protection%20dark%20elegant%20background%20warm%20candlelight%20glow%20close%20up%20product%20photography%20detail&width=600&height=600&seq=insta5&orientation=squarish',
    likes: '1.8K',
    caption: 'Baby bescherming 👶 Hing pasta in de haren — zoals onze moeders dat deden',
    tag: '#hindoestaans',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=blue%20protect%20spray%20bottle%20mystical%20dark%20blue%20aura%20cleansing%20spray%20elegant%20glass%20bottle%20indigo%20blue%20liquid%20shimmer%20protection%20energy%20cleansing%20spiritual%20product%20dark%20background%20close%20up%20detail%20photography&width=600&height=600&seq=insta6&orientation=squarish',
    likes: '756',
    caption: 'Altijd in mijn tas 💜 Blue Protect Spray voor onderweg — directe bescherming',
    tag: '#aura',
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=spiritual%20ritual%20bath%20setup%20dark%20moody%20candles%20crystals%20blue%20water%20bath%20tub%20mystical%20atmosphere%20dark%20bathroom%20spiritual%20cleansing%20ritual%20setup%20atmospheric%20photography&width=600&height=600&seq=insta7&orientation=squarish',
    likes: '4.2K',
    caption: 'Zo ziet het ritueel eruit 🛁 Cologne in het bad + zeep = energetische reset',
    tag: '#surinaams',
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=hing%20asafoetida%20oil%20amber%20golden%20bottle%20dark%20elegant%20mystical%20spiritual%20protection%20oil%20candle%20ritual%20dark%20stone%20background%20warm%20golden%20candlelight%20glow%20close%20up%20product%20photography%20detail&width=600&height=600&seq=insta8&orientation=squarish',
    likes: '1.1K',
    caption: 'Kaarsen versterken met Hing Olie 🕯️ Zo maak je elke kaars een beschermingsritueel',
    tag: '#bescherming',
  },
];

const socialChannels = [
  {
    icon: 'ri-instagram-line',
    name: 'Instagram',
    handle: '@zpiritualz',
    followers: '42K',
    gradient: 'from-pink-500 via-fuchsia-500 to-violet-500',
    href: 'https://www.instagram.com/spiritualshop.nl',
  },
  {
    icon: 'ri-tiktok-line',
    name: 'TikTok',
    handle: '@zpiritualz',
    followers: '87K',
    gradient: 'from-violet-500 via-fuchsia-500 to-pink-500',
    href: 'https://www.tiktok.com/@spiritualshop',
  },
  {
    icon: 'ri-youtube-line',
    name: 'YouTube',
    handle: 'ZpiritualZ',
    followers: '18K',
    gradient: 'from-red-500 via-fuchsia-500 to-violet-500',
    href: 'https://www.youtube.com/@SpiritualShopNL',
  },
];

export const InstagramSection = () => {
  const { t } = useTranslation();
  const [copiedTag, setCopiedTag] = useState<string | null>(null);
  const [hoveredPost, setHoveredPost] = useState<number | null>(null);

  const copyTag = (tag: string) => {
    navigator.clipboard.writeText(tag);
    setCopiedTag(tag);
    setTimeout(() => setCopiedTag(null), 2000);
  };

  const copyAllTags = () => {
    navigator.clipboard.writeText(hashtags.join(' '));
    setCopiedTag('all');
    setTimeout(() => setCopiedTag(null), 2000);
  };

  return (
    <section className="py-24 bg-[#050010] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-gradient-to-r from-pink-600/15 to-violet-600/15 border border-pink-500/20 rounded-full mb-4">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-instagram-line text-pink-400 text-xs" />
              </div>
              <span className="text-pink-300 text-xs font-semibold uppercase tracking-widest">@zpiritualz</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-black text-white mb-3 leading-tight">
              {t('home_insta_title')}{' '}
              <span className="text-transparent bg-gradient-to-r from-pink-400 via-fuchsia-400 to-violet-400 bg-clip-text">
                {t('home_insta_title2')}
              </span>
            </h2>
            <p className="text-white/40 text-sm max-w-lg leading-relaxed">
              {t('home_insta_sub')} <strong className="text-white/60">#zpiritualz</strong> {t('home_insta_sub2')}
            </p>
          </div>

          {/* Social channel pills */}
          <div className="flex flex-wrap gap-3">
            {socialChannels.map(s => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="nofollow noreferrer"
                className="group flex items-center gap-3 px-4 py-2.5 bg-white/5 border border-white/10 rounded-2xl hover:border-white/20 hover:bg-white/8 transition-all duration-300 cursor-pointer"
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-xl bg-gradient-to-br ${s.gradient} shrink-0`}>
                  <i className={`${s.icon} text-white text-sm`} />
                </div>
                <div>
                  <p className="text-white text-xs font-bold leading-none mb-0.5">{s.followers}</p>
                  <p className="text-white/35 text-xs leading-none">{s.name}</p>
                </div>
                <div className="w-4 h-4 flex items-center justify-center text-white/20 group-hover:text-white/50 transition-colors">
                  <i className="ri-arrow-right-up-line text-xs" />
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mb-12">
          {instaPosts.map((post) => (
            <div
              key={post.id}
              className="relative aspect-square rounded-2xl overflow-hidden cursor-pointer group"
              onMouseEnter={() => setHoveredPost(post.id)}
              onMouseLeave={() => setHoveredPost(null)}
            >
              <img
                src={post.image}
                alt={post.caption}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Gradient overlay always */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />

              {/* Tag badge */}
              <div className="absolute top-3 left-3">
                <span className="px-2 py-1 bg-black/40 backdrop-blur-sm text-white/70 text-[10px] font-medium rounded-full">
                  {post.tag}
                </span>
              </div>

              {/* Hover overlay */}
              <div className={`absolute inset-0 bg-gradient-to-t from-[#050010]/95 via-[#050010]/60 to-[#050010]/20 flex flex-col justify-end p-4 transition-opacity duration-300 ${
                hoveredPost === post.id ? 'opacity-100' : 'opacity-0'
              }`}>
                <div className="flex items-center gap-1.5 mb-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-heart-fill text-pink-400 text-xs" />
                  </div>
                  <span className="text-white/70 text-xs font-semibold">{post.likes}</span>
                </div>
                <p className="text-white/80 text-xs leading-relaxed line-clamp-3">{post.caption}</p>
              </div>

              {/* Likes always visible bottom */}
              <div className={`absolute bottom-3 right-3 flex items-center gap-1 transition-opacity duration-300 ${
                hoveredPost === post.id ? 'opacity-0' : 'opacity-100'
              }`}>
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-heart-fill text-pink-400 text-xs" />
                </div>
                <span className="text-white/60 text-xs font-medium">{post.likes}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Hashtag sectie */}
        <div className="bg-gradient-to-r from-violet-900/20 via-fuchsia-900/15 to-violet-900/20 border border-violet-500/15 rounded-3xl p-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-hashtag text-violet-400 text-sm" />
                </div>
                <h3 className="text-white font-bold text-base">{t('home_insta_hashtags_title')}</h3>
                <span className="text-white/30 text-xs">{t('home_insta_hashtags_sub')}</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {hashtags.map(tag => (
                  <button
                    key={tag}
                    onClick={() => copyTag(tag)}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      copiedTag === tag
                        ? 'bg-violet-500/40 border border-violet-400/60 text-violet-200'
                        : 'bg-white/5 border border-white/10 text-white/55 hover:bg-violet-500/15 hover:border-violet-500/30 hover:text-violet-300'
                    }`}
                  >
                    {copiedTag === tag ? (
                      <span className="flex items-center gap-1">
                        <i className="ri-check-line text-xs" />
                        {t('home_insta_copied_tag')}
                      </span>
                    ) : tag}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-3 shrink-0">
              <button
                onClick={copyAllTags}
                className="flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-semibold text-sm rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
              >
                {copiedTag === 'all' ? (
                  <>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-sm" />
                    </div>
                    {t('home_insta_copied')}
                  </>
                ) : (
                  <>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-file-copy-line text-sm" />
                    </div>
                    {t('home_insta_copy_all')}
                  </>
                )}
              </button>
              <a
                href="https://www.instagram.com/spiritualshop.nl"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center justify-center gap-2 px-5 py-3 bg-white/5 border border-white/10 text-white/60 font-medium text-sm rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-instagram-line text-sm" />
                </div>
                {t('home_insta_follow')}
              </a>
            </div>
          </div>

          {/* UGC aanmoediging */}
          <div className="mt-6 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center gap-4">
            <div className="flex -space-x-2">
              {[1,2,3,4,5].map(i => (
                <div key={i} className="w-8 h-8 rounded-full border-2 border-[#050010] overflow-hidden">
                  <img
                    src={`https://readdy.ai/api/search-image?query=spiritual%20woman%20portrait%20dark%20background%20mystical%20glow$%7Bi%7D&width=80&height=80&seq=avatar${i}&orientation=squarish`}
                    alt="klant"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              ))}
            </div>
            <p className="text-white/40 text-sm">
              <strong className="text-white/70">1.200+ {t('home_insta_ugc').split(' ')[0]}</strong> {t('home_insta_ugc').split(' ').slice(1).join(' ')}
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};
